import { CommonContentWrapper } from "../../common/components/content_wrapper/CommonContentWrapper";
import { Padding, Row, SizedBox } from "../../common/components/CommonBaseComponents";
import { PageTitle } from "../../common/components/PageTitle";
import SearchBar from "../../common/components/input/SearchBar";
import { CustomDateFilterButton } from "../../common/components/button/CustomDateFilterButton";
import { useState } from "react";
import { CustomTable, LinkTd } from "../../common/components/table/CustomTable";
import { MarketingDetailModal } from "./modals/MarketingDetailModal";
import Translate from "../../common/translate/Translate";
import PrimaryButton from "../../common/components/button/PrimaryButton";
import SecondaryButton from "../../common/components/button/SecondaryButton";
import TypeFilterButton from "../../common/components/filter_button/TypeFilterButton";
import CategoryFilterButton from "../../common/components/filter_button/CategoryFilterButton";
import { useDevice } from "../../common/hooks/useDevice";
import { useWindowSize } from "../../common/hooks/useWindowSize";

export function MarketingListPage() {
    const [dateFilter, setDateFilter] = useState("All Date");
    const [statusFilter, setStatusFilter] = useState(["all"]);
    const [statusTypeFilter, setStatusTypeFilter] = useState(["all"]);
    const [searchFilter, setSearchFilter] = useState("Coupon Code");

    //임시 state
    const [openDetailModal, setOpenDetailModal] = useState(false);
    const [saveMode, setSaveMode] = useState(false);
    const [detailDto, setDetailDto] = useState({
        couponCode: "CPF001",
        couponName: "",
        type: "",
        amount: "",
        status: "",
        validPeriod: "",
        registeredDate: "",
    });

    const tableHeaders = [
        {
            key: "couponCode",
            label: Translate("marketing.couponCode"),
            render: (row) => (
                <LinkTd
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        setDetailDto({
                            registeredDate: "2025-08-09 13:20:48",
                            couponType: "Free",
                            couponCode: "CPF001",
                            couponName: "Free Coupon",
                            amount: "Free",
                            validShop: "LG Laundry Crew สาขา ลาดหลุมแก้ว",
                            validPeriod: "2025-08-09 ~ 2025-08-16",
                            quota: 1000,
                            reuse: "Resusable",
                            status: "Enable",
                        });
                        setSaveMode(false);
                        setOpenDetailModal(true);
                    }}
                >
                    {row.couponCode}
                </LinkTd>
            ),
        },
        {
            key: "couponName",
            label: Translate("marketing.couponName"),
        },
        {
            key: "type",
            label: Translate("marketing.couponType"),
        },
        {
            key: "amount",
            label: Translate("revenue.amount"),
        },
        {
            key: "status",
            label: Translate("common.status"),
        },
        {
            key: "validPeriod",
            label: Translate("marketing.couponValidPeriod"),
        },
        {
            key: "registeredDate",
            label: Translate("common.registeredDate"),
        },
    ];

    const mockData = [
        {
            couponCode: "CPF001",
            couponName: "Free Cycle Coupon",
            type: "Free",
            amount: "-",
            status: "Enable",
            validPeriod: "2025-08-09 ~ 2025-08-16",
            registeredDate: "2025-08-09 13:20:48",
        },
        {
            couponCode: "CPF001",
            couponName: "50% Discount Coupon",
            type: "Discount",
            amount: "฿60.00",
            status: "Enable",
            validPeriod: "2025-08-09 ~ 2025-08-16",
            registeredDate: "2025-08-09 13:20:48",
        },
        {
            couponCode: "CPF003",
            couponName: "Free Cycle Coupon",
            type: "Free",
            amount: "-",
            status: "Enable",
            validPeriod: "2025-08-09 ~ 2025-08-16",
            registeredDate: "2025-08-09 13:20:48",
        },
        {
            couponCode: "CPF001",
            couponName: "Discount Coupon",
            type: "Discount",
            amount: "฿60.00",
            status: "Enable",
            validPeriod: "2025-08-09 ~ 2025-08-16",
            registeredDate: "2025-08-09 13:20:48",
        },
        {
            couponCode: "CPF001",
            couponName: "Free Cycle Coupon",
            type: "Free",
            amount: "-",
            status: "Enable",
            validPeriod: "2025-08-09 ~ 2025-08-16",
            registeredDate: "2025-08-09 13:20:48",
        },
        {
            couponCode: "CPF001",
            couponName: "Free Cycle Coupon",
            type: "Free",
            amount: "-",
            status: "Enable",
            validPeriod: "2025-08-09 ~ 2025-08-16",
            registeredDate: "2025-08-09 13:20:48",
        },
        {
            couponCode: "CPF001",
            couponName: "Free Cycle Coupon",
            type: "Free",
            amount: "-",
            status: "Enable",
            validPeriod: "2025-08-09 ~ 2025-08-16",
            registeredDate: "2025-08-09 13:20:48",
        },
    ];

    const handleAddCoupon = () => {
        setSaveMode(true);
        setDetailDto({
            couponCode: "CPF001",
            couponName: "",
            type: "",
            amount: "",
            status: "",
            validPeriod: "",
            registeredDate: "",
        });
        setOpenDetailModal(true);
    };

    const currentDevice = useDevice();
    const { width } = useWindowSize();

    let addButton = (
        <PrimaryButton icon={"add_white"} text={Translate("marketing.addCoupon")} onClick={handleAddCoupon} />
    );
    let exportExcelButton = <SecondaryButton icon={"download"} text={Translate("common.exportExcel")} />;
    let pageTitle = <PageTitle title={"Marketing"} contentLength={42} />;

    if (currentDevice === "mobile" || currentDevice === "tablet" || width <= 1240) {
        addButton = <PrimaryButton icon={"add_white"} onlyIcon onClick={handleAddCoupon} />;
        exportExcelButton = <></>;
    }

    if (currentDevice === "mobile" || currentDevice === "tablet") {
        pageTitle = (
            <PageTitle
                title={"Marketing"}
                contentLength={42}
                button={currentDevice === "mobile" || currentDevice === "tablet" ? addButton : undefined}
            />
        );
    }

    const searchBar = (
        <SearchBar
            type={"marketing"}
            currentValue={searchFilter}
            setValue={setSearchFilter}
            totalWidth={currentDevice === "mobile" || currentDevice === "tablet" ? "100%" : undefined}
            selectorWidth={currentDevice === "mobile" || currentDevice === "tablet" ? "20%" : undefined}
            inputWidth={currentDevice === "mobile" || currentDevice === "tablet" ? "70%" : undefined}
        />
    );

    const filterButtons = (
        <>
            <CustomDateFilterButton currentValue={dateFilter} setValue={setDateFilter} />
            <SizedBox width={"10px"} />
            <TypeFilterButton currentValues={statusTypeFilter} setValues={setStatusTypeFilter} type={"marketing"} />
            <SizedBox width={"10px"} />
            <CategoryFilterButton currentValues={statusFilter} setValues={setStatusFilter} type={"marketing"} />
        </>
    );

    let headerSection = (
        <>
            {pageTitle}
            <SizedBox height={"24px"} />
            <Row justifyContent={"space-between"}>
                <Row>
                    {searchBar}
                    <SizedBox width={"10px"} />
                    {filterButtons}
                </Row>
                <Row>
                    {exportExcelButton}
                    <SizedBox width={"13px"} />
                    {addButton}
                </Row>
            </Row>
        </>
    );

    if (currentDevice === "mobile" || currentDevice === "tablet") {
        headerSection = (
            <>
                {pageTitle}
                <SizedBox height={"20px"} />
                {searchBar}
                <SizedBox height={"12px"} />
                <Row>{filterButtons}</Row>
            </>
        );
    }

    return (
        <CommonContentWrapper hasPagination>
            <Padding padding={"24px 20px"}>
                {headerSection}
                <SizedBox height={"20px"} />
                <CustomTable headers={tableHeaders} data={mockData} />
            </Padding>
            {openDetailModal && (
                <MarketingDetailModal
                    isOpen={openDetailModal}
                    onClose={() => setOpenDetailModal(false)}
                    dto={detailDto}
                    isSaveMode={saveMode}
                    title={saveMode ? Translate("marketing.registeration") : Translate("marketing.couponDetail")}
                />
            )}
        </CommonContentWrapper>
    );
}
